// extracted by mini-css-extract-plugin
export default {"buttonCall":"ButtonCall_buttonCall__7Vsej"};